// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Card__cardContainer___JBGE2","cardContent":"Card__cardContent___1P_fX","responsive":"Card__responsive___3Z9FR"};